<template>
    <div class="block-editor add-tag">
        <div class="wrapper">
            <section>
                <a-alert
                    type="info"
                    show-icon
                    :message="$t('chatbotv2.tagAddingDesc')"
                />
            </section>
            <section>
                <div class="title">{{ $t("chatbotv2.tagsToAdding") }}</div>
                <!--@todo translate-->
                <TagDialog v-model="clone.tags" />
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import TagDialog from "../../../../../../components/TagDialog";

const log = log2("AddTag");
export default {
    name: "AddTag",
    components: { TagDialog, TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.add-tag {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
